/* Maniscreen — Main Product Page JS
   Handles: gallery thumbnails | quantity +/- | accordion | sticky ATC bar
*/

(function () {
  'use strict';

  document.querySelectorAll('.msn-pdp').forEach(pdp => {
    const sectionId = pdp.dataset.sectionId;
    const mainImg   = pdp.querySelector(`#MsnMainImg-${sectionId}`);
    const thumbsWrap= pdp.querySelector(`#MsnThumbs-${sectionId}`);
    const qtyInput  = pdp.querySelector(`#MsnQty-${sectionId}`);
    const mainAtc   = pdp.querySelector(`#MsnAtc-${sectionId}`);

    /* ── Gallery thumbnails ────────────────────────── */
    if (thumbsWrap && mainImg) {
      thumbsWrap.querySelectorAll('.msn-pdp__thumb').forEach(thumb => {
        thumb.addEventListener('click', () => {
          const newSrc = thumb.dataset.mediaSrc;
          if (!newSrc) return;
          mainImg.classList.add('loading');
          const preload    = new Image();
          preload.onload   = () => { mainImg.src = newSrc; mainImg.classList.remove('loading'); };
          preload.onerror  = () => { mainImg.src = newSrc; mainImg.classList.remove('loading'); };
          preload.src      = newSrc;
          thumbsWrap.querySelectorAll('.msn-pdp__thumb').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        });
      });
    }

    /* ── Quantity +/- ──────────────────────────────── */
    pdp.querySelectorAll('.msn-pdp__qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const val = parseInt(qtyInput.value, 10) || 1;
        const min = parseInt(qtyInput.min,   10) || 1;
        const max = parseInt(qtyInput.max,   10) || 999;
        qtyInput.value = btn.dataset.action === 'inc'
          ? Math.min(val + 1, max)
          : Math.max(val - 1, min);
      });
    });

    /* ── Read more / less description ──────────────── */
    const descWrap   = pdp.querySelector('[data-msn-desc-wrap]');
    const descEl     = descWrap?.querySelector('[data-msn-desc]');
    const descToggle = descWrap?.querySelector('[data-msn-desc-toggle]');

    if (descEl && descToggle) {
      descEl.classList.add('is-clamped');
      requestAnimationFrame(() => {
        descToggle.hidden = descEl.scrollHeight <= descEl.clientHeight + 1;
      });

      descToggle.addEventListener('click', () => {
        const isExpanded = descToggle.getAttribute('aria-expanded') === 'true';
        descEl.classList.toggle('is-clamped', isExpanded);
        descToggle.setAttribute('aria-expanded', String(!isExpanded));
        descToggle.textContent = isExpanded
          ? descToggle.dataset.readMoreText
          : descToggle.dataset.readLessText;
      });
    }

    /* ── Accordion ─────────────────────────────────── */
    pdp.querySelectorAll('.msn-pdp__acc-trigger').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const isOpen  = trigger.getAttribute('aria-expanded') === 'true';
        const panelId = trigger.getAttribute('aria-controls');
        const panel   = pdp.querySelector(`#${panelId}`);

        pdp.querySelectorAll('.msn-pdp__acc-trigger').forEach(t => {
          if (t !== trigger) {
            t.setAttribute('aria-expanded', 'false');
            const p = pdp.querySelector(`#${t.getAttribute('aria-controls')}`);
            if (p) p.hidden = true;
          }
        });
        trigger.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.hidden = isOpen;
      });
    });

    /* ══════════════════════════════════════════════════
       STICKY ATC BAR
    ══════════════════════════════════════════════════ */
    const stickyBar = document.getElementById(`MsnStickyAtc-${sectionId}`);
    const formId    = stickyBar?.dataset.formId;
    const mainForm  = formId ? document.getElementById(formId) : null;

    /* Show/hide bar: watch the main ATC button via IntersectionObserver */
    if (stickyBar && mainAtc) {
      const atcObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            const visible = !entry.isIntersecting;
            stickyBar.classList.toggle('satc--visible', visible);
            stickyBar.setAttribute('aria-hidden', String(!visible));
          });
        },
        { threshold: 0 }
      );
      atcObserver.observe(mainAtc);
    }

    /* Dropdown: toggle open/close */
    const saTrigger = document.getElementById(`MsnSaTrigger-${sectionId}`);
    const saPanel   = document.getElementById(`MsnSaPanel-${sectionId}`);
    const saWrap    = document.getElementById(`MsnSaWrap-${sectionId}`);

    if (saTrigger && saPanel) {
      saTrigger.addEventListener('click', e => {
        e.stopPropagation();
        const isOpen = saTrigger.getAttribute('aria-expanded') === 'true';
        saTrigger.setAttribute('aria-expanded', String(!isOpen));
        saPanel.hidden = isOpen;
      });

      /* Close panel when clicking outside */
      document.addEventListener('click', e => {
        if (saWrap && !saWrap.contains(e.target)) {
          saTrigger.setAttribute('aria-expanded', 'false');
          saPanel.hidden = true;
        }
      });

      /* Close on Escape */
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && saTrigger.getAttribute('aria-expanded') === 'true') {
          saTrigger.setAttribute('aria-expanded', 'false');
          saPanel.hidden = true;
          saTrigger.focus();
        }
      });
    }

    /* BUY button: submit the main product form */
    const saBuy = document.getElementById(`MsnSaBuy-${sectionId}`);
    if (saBuy && mainForm) {
      saBuy.addEventListener('click', () => {
        if (mainForm.requestSubmit) {
          mainForm.requestSubmit();
        } else {
          mainForm.submit();
        }
      });
    }
  });

})();
